export function parseWebsiteUrl(input) {
  const val = input.trim();
  if (!val) return "";
  if (/^https?:\/\//i.test(val)) return val;
  return "https://" + val;
}

export function parseInstagramHandle(input) {
  const val = input.trim();
  if (!val) return "";
  const urlMatch = val.match(/instagram\.com\/([a-zA-Z0-9_.]+)/i);
  if (urlMatch) return urlMatch[1];
  return val.replace(/^@/, "");
}

export function parseYoutubeHandle(input) {
  const val = input.trim();
  if (!val) return "";
  const channelMatch = val.match(/youtube\.com\/channel\/([^/?#]+)/i);
  if (channelMatch) return channelMatch[1];
  const atMatch = val.match(/youtube\.com\/@([^/?#]+)/i);
  if (atMatch) return atMatch[1];
  const customMatch = val.match(/youtube\.com\/c\/([^/?#]+)/i);
  if (customMatch) return customMatch[1];
  return val.replace(/^@/, "");
}

export const FIELD_CONFIGS = [
  {
    key: "website",
    label: "Website",
    placeholder: "example.com",
    parse: parseWebsiteUrl,
    type: "url",
  },
  {
    key: "instagram",
    label: "Instagram",
    placeholder: "@handle or profile URL",
    parse: parseInstagramHandle,
    type: "creator",
  },
  {
    key: "youtube",
    label: "YouTube",
    placeholder: "@handle or channel URL",
    parse: parseYoutubeHandle,
    type: "creator",
  },
];
